<template>
  <div
    id="app"
  >
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
    html, body, #app {
        padding: 0;
        margin: 0 auto;
        min-height: 100vh;

    }
    #app{
      width: 750px;
    }
  @import "./assets/less/common.less"; // 通用样式

</style>
